import { Pipe, PipeTransform } from '@angular/core';
import { filesize } from 'filesize';

@Pipe({
  name: 'filesize',
  standalone: false,
})
export class FilesizePipe implements PipeTransform {
  transform(value: number, ...args: never[]): string {
    return filesize(value, { standard: 'jedec' });
  }
}
